export default {
  "categoryId": "9a3f82f239c74f83905ef6bbd7f31a8c",
  "title": "Standard A/D Converters",
  "minPartsToRetrieve": "10",
  "queryStrings": {},
  "quickFilter": {},
  "resetColumn": "Reset Column",
  "resetTable": "Reset Table",
  "toLabel": "to",
  "ofLabel" : "of",
  "filtersApplied" : "Applied",
  "numberOfParts":"{part} of {whole}",
  "pageLabel" : "Page",
  "itemsLabel" : "items",
  "copyLinkLabel": "Copy Link",
  "backToLabel": "Back To",
  "sendToEmailLabel": "Send to Email",
  "matchAllValues": "Match all Values",
  "parameterValues": "Parameter Values",
  "defaultValues": "Default Values",
  "showSelectedLabel" : "Show Selected",
  "selectLabel": "Select",
  "selectAllLabel": "Select all rows",
  "availabilityLabel": "Availability",
  "startingFromLabel": "starting from",
  "projectName": "Project Name",
  "confirmHideColumnTitle": "Confirm Hide Column",
  "confirmHideColumnMessage": "Are you sure you want to hide it?",
  "confirmResetTableTitle": "Confirm Reset Table",
  "confirmResetTableMessage": "Are you sure you want to reset the table and remove all filters applied?",
  "confirmResetTable": "Yes, Reset Table",
  "removeFilter": "Remove Filter",
  "dontAskMeAgain": "Don't ask me again",
  "confirm":"Confirm",
  "cancel": "Cancel",
  "download": "Download",
  "pageInput": "Pagination input",
  "quickFilters": "Quick Search",
  "multipleOutputs": "Multiple Outputs",
  "hideColumnConfirm": "Yes, Hide Column",
  "hideColumn": "Hide column",
  "noDataLabel":"There are no parts matching your criteria. Please update or reset the applied filters.",
  "rangeErrorState":"The value range should be from low to high. Acceptable range for this parameter are",
  "acceptableValues" : "Acceptable values for this parameter are",
  "manageColumnsLabel" : "Manage Columns",
  "manageParametersModal":"Manage Parameters modal opened.",
  "setDefaultLabel" : "Set as default table structure",
  "cancelLabel" : "Cancel",
  "updateTableLabel" : "Update table",
  "sortBy" : "Sort By",
  "homeLabel": "Home",
  "sortAndFilterLabel": "Sort",
  "sortAndQuickSearch" : "Sort and Quick Search",
  "sorting": "sorting",
  "sortAscending": "Sorted ascending",
  "sortDescending": "Sorted descending",
  "shareDialogBox": "Share - Opens a dialog box",
  "manageToolsButton" : "Manage Columns",
  "closeModal" : "Close",
  "opensModal" : "Opens a dialog box.",
  "opensNewWindow": "Opens in a new window",
  "searchButtonLabel" : "Apply Filters",
  "onekuListPriceLabel" : "1ku List Price",
  "prevButton":"Previous page",
  "nextButton":"Next page",
  "minValue" : "Min Value",
  "maxValue" : "Max Value",
  "enteredMinValue" : "Entered min value",
  "enteredMaxValue" : "Entered max value",
  "v" : "Volt",
  "a" : "Ampere",
  "sps" : "Samples Per Second",
  "dbfs" : "Decibels Full Scale",
  "db" : "Decibels",
  "lsbs" : "Least Significant Bits",
  "w" : "Watts",
  "vpp" : "Volts Peak-to-Peak",
  "mm2" : "Square Millimeters",
  "mm" : "Millimeters",
  "vs" : "Volt-seconds",
  "ppm" : "Parts Per Million",
  "ppm/degreeC" : "Parts Per Million per Degree Celsius",
  "vRthz" : "Volts per Root Hertz",
  "bits" : "Bits",
  "hz" : "Hertz",
  "deg" : "Degrees",
  "perc" : "Percentage",
  "dollarUS" : "US Dollars",
  "sortButton" : "sorting button",
  "dbc" : "decibels relative to carrier",
  "vus" : "volts per microsecond",
  "dbm" : "decibels milliwatt",
  "vdeg" : "volts per degree Celsius",
  "checkDistributor" : "Check Distributor Inventory",
  "dataSheetsLabel" : "Data Sheet",
  "resultPerPageLabel": "Result Per Page",
  "options": [
    { "value": "Newest", "label": "Latest Launch Day" },
    { "value": "Oldest", "label": "Earliest Launch Day" }
],
   "columns": [
    {
      "id": "C1",
      "field": "0",
      "external_name": "Part #",
      "tooltip": null,
      "display_in_default_view": "true",
      "user_displayable": "true",
      "uom": null,
      "defaultUOM": null,
      "min": "",
      "max": "",
      "values": null,
      "s3Type": null
    },
    {
      "id": "C2",
      "field": "3062",
      "external_name": "Channels",
      "tooltip": "Channels",
      "display_in_default_view": "true",
      "user_displayable": "true",
      "uom": "n/a",
      "defaultUOM": "n/a",
      "min": "",
      "max": "",
      "values": [
        1.0,
        2.0,
        3.0,
        4.0,
        5.0,
        6.0,
        7.0,
        8.0,
        10.0,
        12.0,
        16.0,
        999.0
      ],
      "s3Type": "math"
    },
    {
      "id": "C3",
      "field": "193",
      "external_name": "Bits",
      "tooltip": "ADC Resolution",
      "display_in_default_view": "true",
      "user_displayable": "true",
      "uom": "bits",
      "defaultUOM": "bit",
      "min": "",
      "max": "",
      "values": [
        3.0,
        8.0,
        10.0,
        11.0,
        12.0,
        13.0,
        14.0,
        15.0,
        16.0,
        18.0,
        20.0,
        22.0,
        24.0,
        32.0
      ],
      "s3Type": "math"
    },
    {
      "id": "C4",
      "field": "1746",
      "external_name": "Sample Rate",
      "tooltip": "ADC Output Sample Rate (max)",
      "display_in_default_view": "true",
      "user_displayable": "true",
      "uom": "SPS",
      "defaultUOM": "SPS",
      "min": "6.8",
      "max": "26000000000",
      "values": null,
      "s3Type": "math"
    },
    {
      "id": "C5",
      "field": "4748",
      "external_name": "INL in LSB",
      "tooltip": "INL in LSB (typ)",
      "display_in_default_view": "true",
      "user_displayable": "true",
      "uom": "LSBs",
      "defaultUOM": "LSB",
      "min": "0.04",
      "max": "2147",
      "values": null,
      "s3Type": "math"
    },
    {
      "id": "C6",
      "field": "4907",
      "external_name": "ADC SNR in dBFS",
      "tooltip": "ADC SNR in dBFS (typ)",
      "display_in_default_view": "true",
      "user_displayable": "true",
      "uom": "dBFS",
      "defaultUOM": "dBFS",
      "min": "19.2",
      "max": "148",
      "values": null,
      "s3Type": "math"
    },
    {
      "id": "C7",
      "field": "4364",
      "external_name": "Device Architecture",
      "tooltip": "Device Architecture",
      "display_in_default_view": "true",
      "user_displayable": "true",
      "uom": "n/a",
      "defaultUOM": "n/a",
      "min": "",
      "max": "",
      "values": [
        "Delta Sigma",
        "Flash",
        "Muxed Pipeline",
        "Other",
        "Pipeline",
        "Pipelined",
        "SAR",
        "SAR with Digital Filter",
        "Sigma-Delta",
        "Sigma-Delta Modulator",
        "Simultaneous Sigma Delta"
      ],
      "s3Type": "lookup"
    },
    {
      "id": "C8",
      "field": "4363",
      "external_name": "Input Type",
      "tooltip": "Input Type",
      "display_in_default_view": "true",
      "user_displayable": "true",
      "uom": "n/a",
      "defaultUOM": "n/a",
      "min": "",
      "max": "",
      "values": [
        "3 Differential",
        "Current",
        "Diff-Bip",
        "Differential",
        "Differential with wide input common mode",
        "Diff-Uni",
        "Fully Differential",
        "Pseudo Differential",
        "Pseudo-Differential",
        "SE-Bip",
        "SE-Uni",
        "Single Ended",
        "Single-Ended"
      ],
      "s3Type": "lookup"
    },
    {
      "id": "C9",
      "field": "4365",
      "external_name": "Output Data Format",
      "tooltip": "Output Data Format",
      "display_in_default_view": "true",
      "user_displayable": "true",
      "uom": "n/a",
      "defaultUOM": "n/a",
      "min": "",
      "max": "",
      "values": [
        "Byte",
        "CMOS",
        "I²C",
        "I²S",
        "JESD204",
        "JESD204B",
        "LVDS",
        "Nibble",
        "Parallel",
        "Parallel CMOS",
        "Parallel DDR CMOS",
        "Parallel DDR LVDS",
        "Parallel LVDS",
        "QSPI",
        "Serial",
        "Serial I2C",
        "Serial JESD204",
        "Serial JESD204B",
        "Serial LVDS",
        "Serial SPI",
        "SPI"
      ],
      "s3Type": "lookup"
    },
    {
      "id": "C10",
      "field": "4913",
      "external_name": "Vin Range",
      "tooltip": "Vin Range (typ)",
      "display_in_default_view": "false",
      "user_displayable": "true",
      "uom": "V p-p",
      "defaultUOM": "V p-p",
      "min": "0.039",
      "max": "40",
      "values": null,
      "s3Type": "math"
    },
    {
      "id": "C11",
      "field": "3970",
      "external_name": "Power",
      "tooltip": "Power Dissipation (typ)",
      "display_in_default_view": "true",
      "user_displayable": "true",
      "uom": "W",
      "defaultUOM": "W",
      "min": "0.000021",
      "max": "711",
      "values": null,
      "s3Type": "math"
    },
    {
      "id": "C12",
      "field": "4908",
      "external_name": "SFDR",
      "tooltip": "SFDR-dBc (typ)",
      "display_in_default_view": "false",
      "user_displayable": "true",
      "uom": "dBc",
      "defaultUOM": "dBc",
      "min": "-90",
      "max": "132",
      "values": null,
      "s3Type": "math"
    },
    {
      "id": "C13",
      "field": "1747",
      "external_name": "Vref Source",
      "tooltip": "Vref Source",
      "display_in_default_view": "false",
      "user_displayable": "true",
      "uom": "n/a",
      "defaultUOM": "n/a",
      "min": "",
      "max": "",
      "values": [
        "External",
        "Int/Ext",
        "Internal"
      ],
      "s3Type": "lookup"
    },
    {
      "id": "C14",
      "field": "4369",
      "external_name": "Features",
      "tooltip": "ADC Features",
      "display_in_default_view": "false",
      "user_displayable": "true",
      "uom": "n/a",
      "defaultUOM": "n/a",
      "min": "",
      "max": "",
      "values": [
        "16 channels",
        "2.1Gbps JESD204",
        "50Hz & 60Hz Rejection",
        "5Gbps JESD204B",
        "6Gbps JESD204B",
        "AutoPwrDwn",
        "Buffered Inputs",
        "Clock Duty Cycle Stabilizer",
        "Configurable #channels",
        "Configurable Resolution",
        "Daisy Chain",
        "Data Acquistion System",
        "Data Output Randomizer",
        "DDC",
        "Decimation Filter",
        "De-Muxed Output",
        "Digital Gain Compression",
        "Ease of Use",
        "Easy Drive",
        "General Purpose",
        "GP Outputs",
        "GPIO",
        "High IF Sampling",
        "High Speed",
        "High-Z Mode",
        "Integrated AA Filter",
        "Integrated Digital Filter",
        "Integrated Driver",
        "Integrated I/Q Demodulator",
        "Internal Buffers",
        "Internal Dither",
        "JESD204B Outputs",
        "MUXOUT/ADCIN",
        "No Latency",
        "No Latency 14-Bit 1Msps Output",
        "No Latency 24-Bit 1Msps Output",
        "On-Chip PGA",
        "On-Chip Temp Sensor",
        "Open Wire Detection",
        "Overflow Bit",
        "PGA",
        "PLL",
        "Precision",
        "Programmable FIR Filter",
        "Programmable Sequencer",
        "PwrDwn",
        "Sample Rate Converter",
        "SelfCal",
        "Sigma Delta Modulator",
        "Simultaneous Sampling",
        "SoftSpan",
        "Span Compression Mode",
        "Temp Sensor",
        "Temperature Sensor",
        "User-Defined Filtering"
      ],
      "s3Type": "lookup"
    },
    {
      "id": "C15",
      "field": "4911",
      "external_name": "ADC DNL",
      "tooltip": "ADC DNL (typ)",
      "display_in_default_view": "false",
      "user_displayable": "true",
      "uom": "LSBs",
      "defaultUOM": "LSB",
      "min": "0.05",
      "max": "3.5",
      "values": null,
      "s3Type": "math"
    },
    {
      "id": "C16",
      "field": "4095",
      "external_name": "Vos",
      "tooltip": "Vos (typ)",
      "display_in_default_view": "false",
      "user_displayable": "true",
      "uom": "V",
      "defaultUOM": "V",
      "min": "-0.021875",
      "max": "0.06",
      "values": null,
      "s3Type": "math"
    },
    {
      "id": "C17",
      "field": "1749",
      "external_name": "SINAD",
      "tooltip": "Signal to Noise + Distortion (dB)",
      "display_in_default_view": "false",
      "user_displayable": "true",
      "uom": "dB",
      "defaultUOM": "dB",
      "min": "40",
      "max": "145",
      "values": null,
      "s3Type": "math"
    },
    {
      "id": "C18",
      "field": "4155",
      "external_name": "Aperture Jitter",
      "tooltip": "Aperture Jitter",
      "display_in_default_view": "false",
      "user_displayable": "true",
      "uom": "s rms",
      "defaultUOM": "s rms",
      "min": "0.000000000000043",
      "max": "80",
      "values": null,
      "s3Type": "math"
    },
    {
      "id": "C19",
      "field": "4370",
      "external_name": "Sampling Clk Int/Ext",
      "tooltip": "Sampling Clk Int/Ext",
      "display_in_default_view": "false",
      "user_displayable": "true",
      "uom": "n/a",
      "defaultUOM": "n/a",
      "min": "",
      "max": "",
      "values": [
        "External",
        "Int/Ext",
        "Internal"
      ],
      "s3Type": "lookup"
    },
    {
      "id": "C20",
      "field": "4170",
      "external_name": "ENOB",
      "tooltip": "ADC ENOB (typ)",
      "display_in_default_view": "false",
      "user_displayable": "true",
      "uom": "bits",
      "defaultUOM": "bit",
      "min": "6.02",
      "max": "22.5",
      "values": null,
      "s3Type": "math"
    },
    {
      "id": "C21",
      "field": "4162",
      "external_name": "FPBW",
      "tooltip": "Full Power BW",
      "display_in_default_view": "false",
      "user_displayable": "true",
      "uom": "Hz",
      "defaultUOM": "Hz",
      "min": "23.4",
      "max": "9000000000",
      "values": null,
      "s3Type": "math"
    },
    {
      "id": "C22",
      "field": "4172",
      "external_name": "IMD",
      "tooltip": "IMD",
      "display_in_default_view": "false",
      "user_displayable": "true",
      "uom": "dBc",
      "defaultUOM": "dBc",
      "min": "-134",
      "max": "92",
      "values": null,
      "s3Type": "math"
    },
    {
      "id": "C23",
      "field": "4746",
      "external_name": "ADC INL",
      "tooltip": "ADC INL in LSBs (max)",
      "display_in_default_view": "false",
      "user_displayable": "true",
      "uom": "LSBs",
      "defaultUOM": "LSB",
      "min": "0.1",
      "max": "15032",
      "values": null,
      "s3Type": "math"
    },
    {
      "id": "C24",
      "field": "4914",
      "external_name": "Vref External",
      "tooltip": "Vref External (max)",
      "display_in_default_view": "false",
      "user_displayable": "true",
      "uom": "V",
      "defaultUOM": "V",
      "min": "0.5",
      "max": "10.1",
      "values": null,
      "s3Type": "math"
    },
    {
      "id": "C25",
      "field": "4915",
      "external_name": "Vref External",
      "tooltip": "Vref External (min)",
      "display_in_default_view": "false",
      "user_displayable": "true",
      "uom": "V",
      "defaultUOM": "V",
      "min": "0",
      "max": "9.9",
      "values": null,
      "s3Type": "math"
    },
    {
      "id": "C26",
      "field": "4392",
      "external_name": "Vref Level Internal",
      "tooltip": "Vref Level Internal (typ)",
      "display_in_default_view": "false",
      "user_displayable": "true",
      "uom": "n/a",
      "defaultUOM": "n/a",
      "min": "",
      "max": "",
      "values": [
        "0.5 V",
        "1.0 V",
        "1.15 V",
        "1.17 V",
        "1.18 V",
        "1.19 V",
        "1.2 V",
        "1.25 V",
        "1.3 V",
        "1.35 V",
        "1.75 V",
        "10 V",
        "100 mV",
        "2.048 V",
        "2.25 V",
        "2.32 V",
        "2.35 V",
        "2.4 V",
        "2.47 V",
        "2.5",
        "2.5 V",
        "3.0 V",
        "4.096 V",
        "5.0 V",
        "500 mV",
        "750 mV",
        "990 mV",
        "993 mV",
        "996 mV"
      ],
      "s3Type": "lookup"
    },
    {
      "id": "C27",
      "field": "4202",
      "external_name": "THD",
      "tooltip": "Total Harmonic Distortion",
      "display_in_default_view": "false",
      "user_displayable": "true",
      "uom": "dBc",
      "defaultUOM": "dBc",
      "min": "-126",
      "max": "-49",
      "values": null,
      "s3Type": "math"
    },
    {
      "id": "C28",
      "field": "4026",
      "external_name": "Vs I/O",
      "tooltip": "Vsupply I/O (max)",
      "display_in_default_view": "false",
      "user_displayable": "true",
      "uom": "V",
      "defaultUOM": "V",
      "min": "1.28",
      "max": "5.8",
      "values": null,
      "s3Type": "math"
    },
    {
      "id": "C29",
      "field": "4025",
      "external_name": "Vs I/O",
      "tooltip": "Vsupply I/O (min)",
      "display_in_default_view": "false",
      "user_displayable": "true",
      "uom": "V",
      "defaultUOM": "V",
      "min": "1.22",
      "max": "3",
      "values": null,
      "s3Type": "math"
    },
    {
      "id": "C30",
      "field": "170",
      "external_name": "Vs Unipolar",
      "tooltip": "VSupply Unipolar",
      "display_in_default_view": "false",
      "user_displayable": "true",
      "uom": "n/a",
      "defaultUOM": "n/a",
      "min": "",
      "max": "",
      "values": [
        "No",
        "Yes"
      ],
      "s3Type": "lookup"
    },
    {
      "id": "C31",
      "field": "s3",
      "external_name": "Price (1000+)",
      "tooltip": "US Price 1000 to 4999",
      "display_in_default_view": "true",
      "user_displayable": "true",
      "uom": "$ US",
      "defaultUOM": "$ US",
      "min": "0.98",
      "max": "7000",
      "values": null,
      "s3Type": "math"
    },
    {
      "id": "C32",
      "field": "s5",
      "external_name": "Package",
      "tooltip": "Package",
      "display_in_default_view": "true",
      "user_displayable": "true",
      "uom": "",
      "defaultUOM": "",
      "min": "",
      "max": "",
      "values": [
        "100-Lead TQFP (14mm x 14mm w/ EP)",
        "100-Lead TQFP (14mm x 14mm)",
        "108-Lead LGA (15mm x 11.25mm x 2.32mm)",
        "10-Lead DFN (3mm x 3mm w/ EP)",
        "10-Lead LFCSP (2mm x 3mm w/ EP)",
        "10-Lead LFCSP (3mm x 3mm)",
        "10-Lead MSOP",
        "10-Lead MSOP w/ EP",
        "12-Lead DFN (3mm x 3mm w/ EP)",
        "12-Lead DFN (4mm x 3mm w/ EP)",
        "12-Lead MSOP",
        "140-Lead BGA (11.25mm x 9mm x 2.72mm)",
        "144-Ball CSPBGA (10mm x 10mm x 1.4mm)",
        "144-Ball CSPBGA (10mm x 10mm x 1.7mm)",
        "144-Ball CSPBGA (10mm x 10mm)",
        "14-Lead DFN (4mm x 3mm w/ EP)",
        "14-Lead SOIC",
        "14-Lead TSSOP",
        "16-Lead DFN (4mm x 3mm w/ EP)",
        "16-Lead LFCSP (4mm x 4mm)",
        "16-Lead MSOP",
        "16-Lead MSOP w/ EP",
        "16-Lead PDIP",
        "16-Lead PDIP (Narrow 0.30 Inch)",
        "16-Lead SOIC",
        "16-Lead SOIC (Narrow 0.15 Inch)",
        "16-Lead SOIC (Wide 0.3 Inch)",
        "16-Lead SOIC Wide",
        "16-Lead SSOP (Narrow 0.15 Inch)",
        "16-Lead TSSOP",
        "18-Lead LFCSP (5mm x 4mm x 0.75mm w/ EP)",
        "196-Ball BGA (12mm x 12mm x 1.38mm w/ EP)",
        "196-Ball BGA (12mm x 12mm x 1.42mm w/ EP)",
        "196-Ball BGA (12mm x 12mm)",
        "196-Lead BGA (15mm x 15mm x 2.82mm)",
        "204-Lead LGA (22mm x 15mm x 2.91mm)",
        "20-Ball WLCSP (2.39mm x 2.39mm)",
        "20-Lead CerDIP",
        "20-Lead Flatpack",
        "20-Lead LCC",
        "20-Lead LFCSP (4mm x 4mm w/ EP)",
        "20-Lead PDIP",
        "20-Lead PDIP (Narrow 0.3 Inch)",
        "20-Lead QSOP",
        "20-Lead SOIC (Wide 0.3 Inch)",
        "20-Lead SOIC (Wide)",
        "20-Lead SSOP",
        "20-Lead TSSOP",
        "221-Lead BGA (15mm x 11.25mm x 2.82mm)",
        "24-Lead DFN (7mm x 4mm w/ EP)",
        "24-Lead LFCSP (4mm x 4mm w/ EP)",
        "24-Lead LGA (5mm x 4mm x 1.65mm)",
        "24-Lead PDIP",
        "24-Lead PDIP (Narrow 0.3 Inch)",
        "24-Lead QFN (4mm x 4mm x 0.75mm w/ EP)",
        "24-Lead SOIC (Wide 0.3 Inch)",
        "24-Lead SOIC (Wide)",
        "24-Lead SSOP",
        "24-Lead SSOP (Narrow 0.15 Inch)",
        "24-Lead TSSOP",
        "28-Lead LFCSP (4mm x 5mm x 0.75mm w/ EP)",
        "28-Lead PDIP",
        "28-Lead QFN (4mm x 5mm x 0.75mm w/ EP)",
        "28-Lead SOIC (Wide 0.3 Inch)",
        "28-Lead SOIC (Wide)",
        "28-Lead SSOP",
        "28-Lead SSOP (Narrow 0.15 Inch)",
        "28-Lead TSSOP (4.4mm x 9.7mm)",
        "32-Lead LFCSP (5mm x 5mm w/ EP)",
        "32-Lead LFCSP (5mm x 5mm x 0.75mm w/ EP)",
        "32-Lead LFCSP (5mm x 5mm x 0.85mm w/ EP)",
        "32-Lead LFCSP (5mm x 5mm)",
        "32-Lead QFN (5mm x 5mm x 0.75mm w/ EP)",
        "32-Lead TQFP (7mm x 7mm x 1mm)",
        "36-Lead SSOP",
        "38-Lead QFN (5mm x 7mm w/ EP)",
        "40-Lead LFCSP (6mm x 6mm w/ EP)",
        "40-Lead QFN (6mm x 6mm x 0.75mm w/ EP)",
        "44-Lead LQFP (10mm x 10mm)",
        "44-Lead MQFP (13.2mm x 10mm)",
        "44-Lead MQFP (13.9mm x 10mm)",
        "44-Lead PLCC",
        "44-Lead TQFP (10mm x 10mm)",
        "48-Lead LFCSP (7mm x 7mm w/ EP)",
        "48-Lead LFCSP (7mm x 7mm x 0.85mm w/ EP)",
        "48-Lead LQFP (7mm x 7mm)",
        "48-Lead QFN (7mm x 7mm x 0.75mm w/ EP)",
        "48-Lead SSOP",
        "48-Lead TSSOP",
        "52-Lead FlatPack",
        "52-Lead LQFP (10mm x 10mm)",
        "52-Lead QFN (7mm x 8mm x 0.75mm w/ EP)",
        "52-Lead TQFP (10mm x 10mm w/ EP)",
        "56-Lead LFCSP (8mm x 8mm w/ EP)",
        "56-Lead LFCSP (8mm x 8mm)",
        "64-Ball CSPBGA (8mm x 8mm x 1.55mm)",
        "64-Lead LFCSP (9mm x 9mm w/ EP)",
        "64-Lead LFCSP (9mm x 9mm x 0.75mm w/ EP)",
        "64-Lead LQFP (10mm x 10mm)",
        "64-Lead LQFP (7mm x 7mm)",
        "64-Lead QFN (9mm x 9mm x 0.75mm w/ EP)",
        "64-Lead TQFP (10mm x 10mm w/ EP)",
        "68-Lead CLCC (24.13mm x 24.13mm x 4.45mm)",
        "68-Lead CLCC (24.13mm x 24.13mm x 5.84mm)",
        "6-Lead DFN (2mm x 2mm w/ EP)",
        "6-Lead SC70",
        "6-Lead SOT-23",
        "6-Lead TSOT",
        "72-Lead LFCSP (10mm x 10mm w/ EP)",
        "80-Lead LQFP (14mm x 14mm)",
        "80-Lead TQFP (14mm x 14mm w/ EP)",
        "88-Lead LFCSP (12mm x 12mm w/ EP)",
        "8-Lead DFN (3mm x 2mm w/ EP)",
        "8-Lead LFCSP (2mm x 2mm w/ EP)",
        "8-Lead LFCSP (3mm x 3mm w/ EP)",
        "8-Lead MSOP",
        "8-Lead PDIP",
        "8-Lead PDIP (Narrow 0.3 Inch)",
        "8-Lead SOIC",
        "8-Lead SOIC (Narrow 0.15 Inch)",
        "8-Lead SOT-23",
        "8-Lead TSOT",
        "BGA THERM ENH W/ HEATSINK",
        "CER. FLATPACK WITH LEADS",
        "CERAMIC QUAD FLAT PACK",
        "CERDIP GLASS SEAL",
        "CHIP SCALE BGA",
        "CHIPS OR DIE",
        "LCC:CER LEADLESS CHIP CARR",
        "LFCSP SIDESOLDERABLE",
        "LFCSP:LEADFRM CHIP SCALE",
        "LQFP 1.4 MM",
        "PLASTIC DIP",
        "PLCC:PLASTIC LEAD CHIP CAR",
        "S/B OR B/B CERAMIC DIP",
        "SOIC 300 MIL",
        "SSOP 5.3 MM",
        "TQFP 1.0 MM W/ THERMAL PAD"
      ],
      "s3Type": "lookup"
    },
    {
      "id": "C33",
      "field": "s6",
      "external_name": "Product Description",
      "tooltip": "Product Description",
      "display_in_default_view": "false",
      "user_displayable": "true",
      "uom": "",
      "defaultUOM": "",
      "min": "",
      "max": "",
      "values": null,
      "s3Type": "lookup"
    },
    {
      "id": "C34",
      "field": "s7",
      "external_name": "Status",
      "tooltip": "Status",
      "display_in_default_view": "false",
      "user_displayable": "true",
      "uom": "",
      "defaultUOM": "",
      "min": "",
      "max": "",
      "values": [
        "Not Recommended for New Designs",
        "Pre-Release",
        "Production",
        "Recommended for New Designs"
      ],
      "s3Type": "lookup"
    },
    {
      "id": "C35",
      "field": "s8",
      "external_name": "Eval / Ref Circuit",
      "tooltip": "Eval / Ref Circuit",
      "display_in_default_view": "false",
      "user_displayable": "true",
      "uom": "",
      "defaultUOM": "",
      "min": "",
      "max": "",
      "values": [
        "Evaluation board",
        "Reference circuit"
      ],
      "s3Type": "lookup"
    },
    {
      "id": "C36",
      "field": "s9",
      "external_name": "Export Classification",
      "tooltip": "Export Classification",
      "display_in_default_view": "false",
      "user_displayable": "true",
      "uom": "",
      "defaultUOM": "",
      "min": "",
      "max": "",
      "values": [
        "3A001.a.2.c",
        "3A001.a.5.a.3",
        "3A001.a.5.a.4",
        "3A001.a.5.a.5",
        "3A991.c.1",
        "3A991.c.2",
        "3A991.c.3",
        "3A991.c.4",
        "5A991.b",
        "EAR99"
      ],
      "s3Type": "lookup"
    },
    {
      "id": "C37",
      "field": "s10",
      "external_name": "Automotive",
      "tooltip": "Automotive",
      "display_in_default_view": "false",
      "user_displayable": "true",
      "uom": "",
      "defaultUOM": "n/a",
      "min": "",
      "max": "",
      "values": [
        "No",
        "Yes"
      ],
      "s3Type": "lookup"
    },
    {
      "id": "C38",
      "field": "s13",
      "external_name": "Reliability Level",
      "tooltip": "Reliability Level",
      "display_in_default_view": "false",
      "user_displayable": "true",
      "uom": "",
      "defaultUOM": "n/a",
      "min": "",
      "max": "",
      "values": [
        "883",
        "Automotive",
        "Class S",
        "DIE",
        "EP",
        "High Temp"
      ],
      "s3Type": "lookup"
    },
    {
      "id": "C39",
      "field": "s14",
      "external_name": "Temp Range",
      "tooltip": "Temperature Range",
      "display_in_default_view": "false",
      "user_displayable": "true",
      "uom": "",
      "defaultUOM": "n/a",
      "min": "",
      "max": "",
      "values": [
        "0 to 70°C",
        "0 to 85°C",
        "-10 to 85°C",
        "-25 to 85°C",
        "-40 to 105°C",
        "-40 to 125°C",
        "-40 to 85°C",
        "-45 to 85°C",
        "-55 to 105°C",
        "-55 to 110°C",
        "-55 to 125°C",
        "-55 to 210°C",
        "-55 to 85°C"
      ],
      "s3Type": "lookup"
    },
    {
      "id": "C40",
      "field": "s16",
      "external_name": "Package Area",
      "tooltip": "Package Area",
      "display_in_default_view": "false",
      "user_displayable": "true",
      "uom": "",
      "defaultUOM": "n/a",
      "min": "4",
      "max": "1375.223",
      "values": null,
      "s3Type": "math"
    },
    {
      "id": "C41",
      "field": "s17",
      "external_name": "Package Height",
      "tooltip": "Package Height",
      "display_in_default_view": "false",
      "user_displayable": "true",
      "uom": "",
      "defaultUOM": "n/a",
      "min": "0.5",
      "max": "7.366",
      "values": null,
      "s3Type": "math"
    },
    {
      "id": "C42",
      "field": "s18",
      "external_name": "Launch Date",
      "tooltip": "Launch Date",
      "display_in_default_view": "false",
      "user_displayable": "true",
      "uom": "",
      "defaultUOM": "n/a",
      "min": "",
      "max": "",
      "values": null,
      "s3Type": "lookup"
    },
    {
      "id": "C43",
      "field": "s22",
      "external_name": "Terminal Finish",
      "tooltip": "Terminal Finish",
      "display_in_default_view": "false",
      "user_displayable": "true",
      "uom": "",
      "defaultUOM": "n/a",
      "min": "",
      "max": "",
      "values": [
        "E1",
        "E3",
        "E4",
        "GC",
        "GN",
        "NA",
        "PB",
        "X3"
      ],
      "s3Type": "lookup"
    },
    {
      "id": "C44",
      "field": "s24",
      "external_name": "EP",
      "tooltip": "EP",
      "display_in_default_view": "false",
      "user_displayable": "true",
      "uom": "",
      "defaultUOM": "n/a",
      "min": "",
      "max": "",
      "values": [
        "No",
        "Yes"
      ],
      "s3Type": "lookup"
    }
  ]
};